export const Bio = {
  name: "Niloy Sarkar Babu",
  roles: [
    "Frontend Developer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/sarkarniloy102",
  resume:
    "https://drive.google.com/file/d/1FDIpJuXxN0OSR-iaTsQxMkdtzzUHUPRd/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/niloy-sarkar-babu-24758b203/",
  twitter: "https://x.com/NiloySa54859184",
  insta: "https://www.instagram.com/sarkarniloy_/",
  facebook: "https://www.facebook.com/rj.niloy.90226628/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },

      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOAAAADgCAMAAAAt85rTAAAAh1BMVEX///8Af/8Ad/8AfP8Aev/v+P8Adf8Ae/+Puv8Adv+72P8Ac/87k/8Agf/t9f/6/f/U5v+lyf/m8f+10//H3v/C2/9Tnf9npv/e7P+w0P9+s/9Il/+Ywf8rjP8xkP/A2f8ch//Q4/9zrf94r/+HuP+dxP8JhP9aoP/a6f9Mmv+py/+Tv/8Ab/9IeMWVAAAHEElEQVR4nO2d6XqqMBBAJUQodcG1tlqpS2tre9//+W6oWgWyTAiB4DfnNwaOZiQkk6HTQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQZCm2X5Pu3Wda/Y91zl8Mhoan3KY9AghD8btQJgeAhL5YMVtEgTRp+GXHx9Cj0EGU7N2AHz1g/RUXm8EOry76PnsaHqIjc76SrwTQQI7b1nO18vw+5Djx4SeDifvRuc9ns/KzhsszDu8kFcSXk7kRerfZLsmf9e1MTpx8ifoeSH5MWpLzOOBXE/jEVVYxX+/9q+h0alvBW2F4tcq8DwNwb/eWb0g6z79qkOxuwty55ALjtYke3i1gp7fW1R6V/ygNHcGqWA30zttCLJQjF6Nmrzl7UAK7csEx1FYOLxyQXYFhzejRi8854JPKbjjHW9BkN0VV89GzabE+3zwqQTnPd7hVgRZKO4MQzH3XwgRXBT7pzVBNkaiHwbtzjec4FMJ9rkXY0vQJBQnT4X/QhcF2eitVCjGS5meS4Kp4l47FMe+KPgcFNQPxVl+INKw4FolmIYi/ClcHnyOCrJ+eoSFYvweAZpzTzBVXAKeq79VweeuYBqKY0VL23UEa0pXMKxFkF3WeiZpZ/gpGJeZCw5qEmSjt6eJqJl3zlNARYJ0UZdgqsgPxRdg8JUR9CPht1q9IPs6ve9CE9sEGnwlBKm/NfLTFfS8KBeKw+IjeHWCoi5jU5Cd9POm0zwEGsGnKxj1zZ9K9QXT6cX38/c6HSjHZeUFqfdirFdO8DcUmeKsz52RqEawgt5pIMgukhwoKftZkeDq2mAVcyZGgiYIBZeXu001vfOXTf1+YsHJqctX1TvdE+zMCQ1pZb3TQcHO8Gex11oDbptg9aAgCrZX0De5Rco+7IYgJUk/LDPSPH14nRTXBZ0SjH4nfKHTSFnYjZp9OP4RPSa6IEjPuRvxkug+DvnBZWZjKjB0QfA60TN5gs8m/V795vpAfOR/0gHBcHdzyEyyEpYnO9H/zf+gA4I0m7umXE45k1+qeXRA8AARVC6InSiMktsjyELxqFLkLJe2SVC+KJ0GHyf3ZNoqQW5OzxlB9lDbBDvxjt9Pg/4X9/jWCfJTe8QZfC0UZH8cuanQMBDnYLZSMJvbyoJPkkXbUsFOd3EZvUXyPGhTwfnuacmPbjhlBDudUcIUfeIrZi/NBFm8hz7tmeRbdcoKsms/HhJlArSJYPfyj92TLSyrGZQUBGEgeL3n+k9G1+CmYHbUZHQNVgVfygk+Z8e9Zmkk7gnG+1w20Z0JFp8970qQN3twT4LchIY7Elxwj78fwck/7uH3Iyg4/H4EBbOMZoLcJlEQxvNKb2a7ZYLCnT13Iije2XMXgtL1DJHguDWCis0FbRdULmS0XFC9FFWrIP+7Li8I2NkjFuR/My4Jgnb2tFcwfodlkLZVEJySUatg2XnRAjPwzh5hLQsrgntuo9qCk0/45gJ/JWjEiuCQcrfTaApq7ewR1pP5sCHYeeYNqvQEtXb2UF84FW9HkHtn1hEc6ezs8SNJOrYtQc7YCi6otbNHtn/NpmDxBg0W1NrZI9+BaFUw/3wDFNTa2UND1R5Sq4Lpn/S1fQqpfTRKNHb2QPZCWBZkofi36hEAUvvn/zSCD7SP27Zgmq91mkYJ14CDBXlaPMgGtBfCvmAaigGlwQZSfwwsSAlwmb0OQfbHsVzCKnMBBf0AXJimHkEwMMFgBc8DeW2foF6dNn5BIIcFQ16KpZihYETrqqA8y4sDvw6Cs4KKLK8CbwPRoM9JQV+zSGK+/KHrgv5Ga49qV7hO46og0coRFKdKuyroJxrtyJPd3RQM4RVSLsPfdgn6R2AboA0nDgp6FDb8HMuDz2FBUB+FrNO4KugRZf1v2DqNs4Kqis/xErwr0bAMdXlUY1HZk8TYg08V11Smvoj6aUJUfF1nx6VH9QZFFQJ4HuQWX59oVGBLW2jKD/ZEHxY6mNY6TbQ2rMllAnBOJlv7Rm+dprqyOWUAz6pFyeVngJc/9G5LYzXEF7dmNI/zs73OImmuuFkzaJSDCnv9Rb/XluC7MNGJJz/UKDfAKzDYBJzC+1VQac0qQ0YlS8dJ9aSLpLVTrvifGNUiaQP86Px5KKBEtUjaBJWFIqxUchNoJVqI9Y5OBV+WqWcaijrlyhvhQbt00C00NNyLXAPDhV7poBvKvDKgCbTSLm7oVVqt0Spl7orOB18W3VA0e/FKE2gmr5m+OqcJ4APUakul1sgLKBTJ4bHpCy2PeoAaBtW9gKwJFKHYzuDLIhugRoIiUC1jKpigr+ONqjXBuyvaexFnExQGqHZfpdoE2ddt2H4ZbiNcB6hk0OhcvD1OoRhGD47OSJjDQrF3d8GXw+H5FgRBEARBEARBEARBEARBEARBEARBEARBEMZ/Z7h0SlKcxhsAAAAASUVORK5CYII=",
      }
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },
      {
        name: "Figma",
        image:
          "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    role: "DevOps & Fullstack Engineering Intern",
    company: "Flipr Inovations Pvt. Ltd.",
    date: "Aug 2023 - July 2023",
    desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
    skills: [
      "Docker",
      "Terraform",
      "AWS",
      "EC2",
      "Portainer",
      "Nginx",
      "JavaScript",
      "TypeScript",
      "Node Js",
      " Next Js",
    ],
    doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
    role: "Frontend Engineer Intern",
    company: "Neurobit",
    date: "June 2023 - Present",
    desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    role: "Fullstack Externship",
    company: "Flipr",
    date: "June 2023 - July 2023",
    desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
      "Docker",
      "AWS",
      "MongoDB",
    ],
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    role: "Open Source Contributor ",
    company: "GirlScript Summer of Code",
    date: "May 2023 - Present",
    desc: "Contributing to different open-source projects and learn from industry experts",
    doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    role: "Android Developer",
    company: "DSC KIIT",
    date: "Nov2021 - Present",
    desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
    skills: [
      "Leadership",
      "Mobile Application Development",
      "Kotlin",
      "XML",
      "Figma",
    ],
  },
  {
    id: 4,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
    role: "Android Developer Intern",
    company: "Rudraksha Welffare Foundation",
    date: "June 2021 - Oct 2021",
    desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
    skills: [
      "Android",
      "Java",
      "Kotlin",
      "XML",
      "Node Js",
      "Cloud Firestore",
      "Firebase",
      "Figma",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  },
];

export const education = [
  {
    id: 0,
    img: "https://i.ibb.co.com/dPpNdjw/iiuc.png",
    school: "International Islamic University,Chittagong",
    degree: "Bachelor of Science - B.Sc, Computer Science and Engineering",
    date: "Sep 2019 - Oct 2024",
    desc: "I have completed my BSc in Computer Science and Engineering from International Islamic University,Chittagong",

  },
  {
    id: 1,
    img: "https://i.ibb.co.com/WnQxC18/clg.jpg",
    school: "Sir Ashutosh Govt. College",
    date: "2016 - 2018",
    desc: "I have completed my H.S.C degree at Sir A.T Govt. College",
    degree: "Higher Secondary Certificate, Science Division",
  },
  {
    id: 2,
    img: "https://i.ibb.co.com/mN7KP5p/schl.jpg",
    school: "Purno Chandro Sen Saroatali High School",
    date: "2014 -2016",
    desc: "I  completed my class 10 education at P.C Sen Saroatali High School",
    degree: "Secondary School Certificate, Science Division",
  },
];

export const projects = [
  {
    id: 14,
    title: "TourBDirect",
    date: "Dec 2023",
    description:
      "The TourBDirect project is a scalable and robust travel booking platform developed using the MEARN stack . Hosted on Netlify, it offers a seamless experience for users to browse and book travel tours. The platform features dynamic tour listings with detailed itineraries, pricing, and destinations.  It serves as a platform for users to explore and book various tours and travel packages, offering a user-friendly interface that allows for easy navigation and interaction. The application includes functionalities such as viewing available tours, booking options, and detailed itineraries. By leveraging modern web technologies, the project ensures a seamless and engaging experience for users looking to plan their next adventure.",
    image:
      "https://i.ibb.co.com/kMSR6fy/TBD.png",
    tags: ["tailwind", "daisy ui", "mamba ui", "React Js", "tanstack query", "firebase", "node Js", "express js"],
    category: "Mearn Stack",
    github: "https://github.com/sarkarniloy102/TourBDirect-Client",
    webapp: "https://tourbdirect.netlify.app/",
  },
  {
    id: 15,
    title: "Career Maker",
    date: "Nov 2023",
    description:
      "The CareerMaker project is a dynamic web application built with React and Vite, hosted on Netlify. It offers users a seamless experience to explore various career opportunities, with features like comprehensive **job listings**, detailed **application forms**, and valuable **career resources**. The project showcases a **user-friendly interface**, dynamic content rendering, and real-time updates. Designed with modern web technologies, it provides a smooth and efficient experience for job seekers. Hosted on Netlify, the application ensures quick loading times and optimal performance across different devices and browsers. Server side: 'https://github.com/sarkarniloy102/CareerMaker_ServerSide' ",
    image:
      "https://i.ibb.co.com/K039nLk/CM.png",
    tags: ["tailwind", "daisy ui", "mamba ui", "React Js", "Axios", "firebase", "node Js", "express js", "mongoDB"],
    category: "Mearn Stack",
    github: "https://github.com/sarkarniloy102/CareerMaker_ClientSide",
    webapp: "https://careermakeer.netlify.app/",
  },
  {
    id: 13,
    title: "Event Management",
    date: "Oct 2023",
    description:
      "Developed a dynamic web application developed using React and Vite, hosted on Netlify. It offers features such as user authentication, event management services, and a review section for clients to leave feedback. The application demonstrates proficiency in modern web development technologies, providing a seamless experience for users to manage and review events.  ",
    image:
      "https://i.ibb.co.com/X7XtgrB/EM.png",
    tags: ["tailwind", "daisy ui", "React Js", "firebase"],
    category: "Mearn Stack",
    github: "https://github.com/sarkarniloy102/EventManagement",
    webapp: "https://event-managemente.netlify.app/",
  },
  {
    id: 7,
    title: "Summer Sale",
    date: "Aug 2023",
    description:
      "In this project, I've integrated JavaScript along with HTML and Tailwind CSS to add interactive features like dynamic content updates, coupon validation, and real-time price calculations. Let me know if you'd like to enhance or modify any specific functionality!",
    image:
      "https://i.ibb.co.com/WDpwk4D/SS.png",
    tags: ["html", "tailwind-css", "javascript"],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/summer-sale",
    webapp: "https://sarkarniloy102.github.io/summer-sale/",
  },
  {
    id: 8,
    title: "PH tube",
    date: "Sep 2023",
    description:
      "This project is developed using HTML, Tailwind CSS, and JavaScript, featuring a video streaming platform that allows users to watch and sort videos by view count. The site includes a Blog section, providing additional content related to the videos. ",
    image:
      "https://i.ibb.co.com/f28mV22/PT.png",
    tags: ["html", "tailwind", "daisy ui", "javascript"],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/PHero-tube",
    webapp: "https://sarkarniloy102.github.io/PHero-tube/",
  },
  {
    id: 12,
    title: "Course Registration",
    date: "Sep 2023",
    description:
      "This project is a dynamic web application developed using React and Vite, hosted on Netlify. It allows users to register for courses, providing an interactive and user-friendly interface ",
    image:
      "https://i.ibb.co.com/ThzYpMr/CRe.png",
    tags: ["tailwind", "daisy ui", "React Js"],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/CourseRegistration",
    webapp: "https://courseregistrationn.netlify.app/",
  },
  {
    id: 2,
    title: "Registration Form",
    date: "Jul 2023",
    description:
      "Developed a static website featuring a responsive registration form, allowing users to input their details like name, email, and password. This project showcases expertise in HTML and CSS for creating interactive and visually engaging web forms.",
    image:
      "https://i.ibb.co.com/3r9zkSr/RF.png",
    tags: ["html", "css"],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/Registration_form",
    webapp: "https://sarkarniloy102.github.io/Registration_form/",

  },
  {
    id: 3,
    title: "Gamer Zone",
    date: "Jul 2023",
    description:
      "This project is a static website for Gamer Zone, showcasing a gaming platform's landing page with sections for games, developers, and promotions. It highlights features like instant play, various game categories, and a user-friendly interface.",
    image:
      "https://i.ibb.co.com/C7TCf6r/GZ.png",
    tags: ["html", "css"],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/B8A2_Gamer_Zone",
    webapp: "https://sarkarniloy102.github.io/B8A2_Gamer_Zone/",
  },
  {
    id: 10,
    title: "Tea House",
    date: "Jul 2023",
    description:
      "The Tea House project is a static website designed to showcase a tea shop's offerings. It features sections such as 'Our Featured Products', highlighting various teas like Milk Tea, Black Tea, Lemon Tea, and Green Tea. The site also includes customer testimonials, news and events, and a call-to-action for users to get started. The design emphasizes a clean and user-friendly interface, aiming to provide an engaging experience for visitors interested in tea products.  ",
    image:
      "https://i.ibb.co.com/vv23nNz/TH.png",
    tags: ["html", "css"],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/Tea_House",
    webapp: "https://sarkarniloy102.github.io/Tea_House/",
  },
  {
    id: 4,
    title: "Fruit Burst",
    date: "Jul 2023",
    description:
      "Developed a static website for 'Fruit Burst', showcasing a variety of fresh fruits with sections like featured products, deals of the day, and team introductions, offering an engaging and visually appealing experience for fruit enthusiasts.",
    image:
      "https://i.ibb.co.com/0mvGGy6/FB.png",
    tags: ["html", "css"],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/fruit_brust",
    webapp: "https://sarkarniloy102.github.io/fruit_brust/",
  },
  {
    id: 5,
    title: "Baper Bank",
    date: "Aug 2023",
    description:
      " This project is developed using HTML, Tailwind CSS, and the Document Object Model (DOM) concept. It features a login page where users can access the bank's services. The project demonstrates proficiency in web development technologies and the application of DOM for interactive elements. For more details, you can visit the project's GitHub repository. For Login, [email:sarkarniloy102@gmail.com, Password: Niloy102]",
    image:
      "https://i.ibb.co.com/cDT97T4/BB.png",
    tags: ["html", "tailwind css", "Javascript(DOM)"],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/Baper_Bank",
    webapp: "https://sarkarniloy102.github.io/Baper_Bank/",
  },
  {
    id: 6,
    title: "React world tour",
    date: "Sep 2023",
    description:
      "This project includes a dynamic API fetch feature, allowing it to retrieve and display data from external sources in real-time. This functionality demonstrates the integration of REST APIs within React components, showcasing state management and asynchronous operations with tools like fetch()",
    image:
      "https://i.ibb.co.com/d2KSz1z/RWT.png",
    tags: ["React Js", "API", "fetch"],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/Country_tour",
    webapp: "https://reactworldtourr.netlify.app/",
  },
  {
    id: 1,
    title: "The Chocolate Gallery",
    date: "Jul 2023",
    description:
      "This project is a static website that showcases a variety of chocolate products and related services. The site features sections highlighting available products, customizable packages, customer reviews, and blog posts about different chocolate varieties. It also offers information on services like cash on delivery and fast delivery options. The website is designed to provide users with an overview of chocolate offerings and related information in a structured format.",
    image:
      "https://i.ibb.co.com/v3sxhLB/TCG.png",
    tags: [
      "html",
      "css",
      "javascript"
    ],
    category: "web app",
    github: "https://github.com/sarkarniloy102/the_chocolate_gallery",
    webapp: "https://sarkarniloy102.github.io/the_chocolate_gallery/",
  },
  {
    id: 9,
    title: "Email template",
    date: "Jun 2023",
    description:
      "The Email_Template contains a responsive design for effective email communication. Let me know if you'd like help improving or customizing it!",
    image:
      "https://i.ibb.co.com/j5D23h5/ET.png",
    tags: [
      "html",
      "css"
    ],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/Email_Template",
    webapp: "https://sarkarniloy102.github.io/Email_Template/",
  },
  {
    id: 0,
    title: "Replica of Facebook's login page",
    date: "Jun 2023",
    description:
      "This project replicates Facebook's login page, showcasing a responsive design with key elements like login fields, a 'Create an account' section, and language options. It demonstrates skills in HTML and CSS for recreating the layout of a popular platform. Note that it is non-functional and intended solely for educational purposes.",
    image:
      "https://i.ibb.co.com/26t6VrT/Flog.png",
    tags: ["html", "css"],
    category: "Frontend",
    github: "https://github.com/sarkarniloy102/facebook_front_page",
    webapp: "https://sarkarniloy102.github.io/facebook_front_page/",

  },
  {
    id: 16,
    title: "Student Result",
    date: "Apr 2021",
    description:
      "The Student-Result project is a Java-based application developed to manage and display student results effectively. Built using the NetBeans IDE, it employs Apache Ant for automated building and deployment, ensuring streamlined development. The project likely facilitates result input, processing, and display, offering functionalities such as grade calculation, validation, and report generation. It demonstrates a structured approach to creating a functional tool for academic result management, packaged for easy distribution and use.",
    image:
      "https://i.ibb.co.com/VWvzRxY/SR.png",
    tags: ["java"],
    category: "Academic",
    github: "https://github.com/sarkarniloy102/Student-Result",
    webapp: "https://github.com/sarkarniloy102/Student-Result/blob/main/src/result/result.java",

  },
  {
    id: 17,
    title: "Stopwatch",
    date: "Feb 2021",
    description:
      "The StopWatch project is a Java-based graphical application that provides a simple stopwatch functionality. Developed using the Swing framework, it features an intuitive user interface with 'Start' and 'Stop' buttons for timing control. The application utilizes Java's System.nanoTime() method to measure elapsed time with high precision. It calculates and displays the elapsed time in seconds, providing accurate and user-friendly feedback. This project demonstrates the effective use of Java Swing for GUI development and implements event-driven programming to create an interactive and functional timing tool.",
    image:
      "https://i.ibb.co.com/jgJRNhc/SW.png",
    tags: ["java"],
    category: "Academic",
    github: "https://github.com/sarkarniloy102/StopWatch",
    webapp: "https://github.com/sarkarniloy102/StopWatch/blob/main/src/stopwatch2.java",

  },
  {
    id: 18,
    title: "Jarvis AI",
    date: "Nov 2022",
    description:
      "The 'Iron-Man-Jarvis' project is a Python-based voice assistant inspired by J.A.R.V.I.S. from the Iron Man series. Developed using Python, it integrates various libraries to enable functionalities such as speech recognition, text-to-speech conversion, and task automation. The assistant can interpret voice commands to perform actions like opening applications, searching the web, and retrieving information, aiming to emulate the interactive and responsive nature of Tony Stark's AI system.",
    image:
      "https://i.ibb.co.com/VxBGbgF/IMJ.png",
    tags: ["python", "pyautogui", "pyttsx3"],
    category: "Academic",
    github: "https://github.com/sarkarniloy102/Iron-Man-Jarvis",
    webapp: "https://github.com/sarkarniloy102/Iron-Man-Jarvis/blob/main/jarvis.py",
    member: [
      {
        name: "Niloy Sarkar Babu",
        img: "https://i.ibb.co.com/54DfJTp/Hero-Image.png",
        linkedin: "https://www.linkedin.com/in/niloy-sarkar-babu-24758b203/",
        github: "https://github.com/sarkarniloy102",
      },
      {
        name: "Mainuddin Hasan Manik",
        img: "https://i.ibb.co.com/s2jWKZ0/MHM.jpg",
        linkedin: "https://www.linkedin.com/in/muh-manik/",
        github: "https://github.com/",
      },
      {
        name: "Adnan Araf",
        img: "https://i.ibb.co.com/XSCGgV8/AA.png",
        linkedin: "https://www.linkedin.com/in/adnan-araf-554483202/",
        github: "https://github.com/adnanaraf",
      },

    ],

  },
  {
    id: 19,
    title: "Non-Linear Equation Solution Project Using Numerical Methods",
    date: "May 2023",
    description:
      "In this project aims to solve the non-linear equation(x2 - 1) sin(x) = 2x cos(x) using four different numerical methods: Newton Bisection method, Newton-Raphson method, False Position method, and Secant method. Through the implementation and comparison of these methods, we expect to gain insights into their performance, convergence rate, accuracy, computational efficiency, and robustness. The findings of this project can be useful in selecting an appropriate numerical method for solving similar non-linear equations in various real-world applications.",
    image:
      "https://i.ibb.co.com/DMRzYbd/NM.png",
    tags: ["C++","Algorithms"],
    category: "Academic",
    github: "https://github.com/sarkarniloy102/Numerical-Methods",
    webapp: "https://github.com/sarkarniloy102/Numerical-Methods/blob/main/Root_Finders_Project_Code.cpp",
    member: [
      {
        name: "Emon Biswas",
        img: "https://i.ibb.co.com/C9fH3r6/EB.jpg",
        linkedin: "https://www.linkedin.com/in/imebiswas/",
        github: "https://github.com/",
      },
      {
        name: "Niloy Sarkar Babu",
        img: "https://i.ibb.co.com/54DfJTp/Hero-Image.png",
        linkedin: "https://www.linkedin.com/in/niloy-sarkar-babu-24758b203/",
        github: "https://github.com/sarkarniloy102",
      },

      {
        name: "Mainuddin Hasan Manik",
        img: "https://i.ibb.co.com/s2jWKZ0/MHM.jpg",
        linkedin: "https://www.linkedin.com/in/muh-manik/",
        github: "https://github.com/",
      },

    ],

  },





];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];